import { Drawer, Box, Typography, IconButton, Grid} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { Menustyling, Liststyling, Listdrawer, NavBtn } from '../styling/style';
import styled from '@emotion/styled';
import Logo from '../assets/logo.png';

const LogoImage = styled.img`
    width: 100%;
    height: auto;
    max-width: 170px;
`;
const GridS = styled(Grid)`
    padding: 30px 15px 20px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #ffff;
`;

export const MuiDrawer = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const toggleDrawer = (open) => (event) => {setIsDrawerOpen(open)};
    return (
        <>
        <NavBtn>
            <IconButton className="nav-btn" size='large' edge='start' color='inherit' aria-label='logo' onClick={toggleDrawer(true)}>
                <MenuIcon/>
            </IconButton>
            </NavBtn>
            <Drawer
                anchor='left'
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                className="drawer"
            >
            <div style={{backgroundColor: 'black', overflowY: 'hidden'}}>
                <Box p={2} padding='0px' width='250px' textAlign='center' role='presentation'>
                    <GridS xs={12} >
                        <LogoImage src={Logo}/>
                    </GridS>
                    <Menustyling onClick={() => setIsDrawerOpen(false)}>
                        <Typography variant='h6' component='div'></Typography>
                        <Liststyling><Listdrawer href="/">Home</Listdrawer></Liststyling>
                        <Liststyling><Listdrawer href="/#about">About</Listdrawer></Liststyling>
                        <Liststyling><Listdrawer href="/#features">Features</Listdrawer></Liststyling>
                        {/* <Liststyling><Listdrawer href="/walloffame">Wall Of Fame</Listdrawer></Liststyling> */}
                        <Liststyling><Listdrawer href="/#">$PEACHY</Listdrawer></Liststyling>
                        {/* <Liststyling><Listdrawer href="/#">Whitepaper</Listdrawer></Liststyling>
                        <Liststyling><Listdrawer href="/#faq">FAQ</Listdrawer></Liststyling> */}
                    </Menustyling>
                </Box>
            </div>
            </Drawer>
        </>
    );
};